import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { X, CheckCircle2 } from "lucide-react";
import { UniversalLeadForm } from "@/components/forms/UniversalLeadForm";

interface SchedulingFormProps {
  isOpen: boolean;
  onClose: () => void;
  preSelectedService?: string;
}

export const SchedulingForm = ({ isOpen, onClose, preSelectedService }: SchedulingFormProps) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [submittedName, setSubmittedName] = useState("");

  if (!isOpen) return null;

  if (showSuccess) {
    return (
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => { setShowSuccess(false); onClose(); }}
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-background border rounded-lg shadow-xl max-w-md w-full p-8 text-center"
          >
            <CheckCircle2 className="h-16 w-16 text-primary mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-2">Thank You!</h2>
            <p className="text-muted-foreground mb-6">
              We'll be in touch within 2 business hours.
            </p>
            <Button onClick={() => { setShowSuccess(false); onClose(); }} className="w-full">
              Close
            </Button>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    );
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.95, opacity: 0, y: 20 }}
          onClick={(e) => e.stopPropagation()}
          className="bg-[rgba(10,17,40,0.95)] backdrop-blur-[10px] border border-primary/20 rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
        >
          <div className="sticky top-0 bg-[rgba(10,17,40,0.98)] border-b border-primary/20 p-6 flex justify-between items-center z-10">
            <h2 className="text-2xl font-bold text-white">Get Connected with SimNet</h2>
            <Button variant="ghost" size="icon" onClick={onClose} className="text-white hover:bg-white/10">
              <X className="h-5 w-5" />
            </Button>
          </div>

          <div className="p-6">
            <UniversalLeadForm
              preSelectedService={preSelectedService}
              source="demo_request"
              variant="dark"
              buttonText="Request Consultation"
              onSuccess={() => setShowSuccess(true)}
            />
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
